import { Directive, OnInit, ElementRef } from '@angular/core';

@Directive({
  selector: '[appInputAutoFocus]'
})
export class InputAutoFocusDirective implements OnInit {

  constructor(private elementRef: ElementRef) { };

  ngOnInit(): void {
    this.elementRef.nativeElement.focus();
  }
} 






// WEBPACK FOOTER //
// ./src/app/sharedcomponents/_directive/Autofocus/input-auto-focus.directive.ts